module.exports = __webpack_public_path__ + "static/media/XBOX2.b64ff3db.png";